// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".legacy." + {"2897":"502f9f0da99364e72251","6400":"8ad557cb354770755570"}[chunkId] + ".js";
};